import { DEBUG_MODE, DEF_STORE_ID } from "./enums";
import localForage from "localforage";
import {Chart} from "chart.js/auto";

export function debug(msg: string, type: number = DEBUG_MODE.NOTICE) {
    store(false).get(DEBUG_MODE.KEY).then((currLvl: unknown) => {
        if (currLvl as number >= type) {
            let color, heading = "";
            switch (type) {
                case DEBUG_MODE.ERROR:
                    heading = "📕 Error:";
                    color = DEBUG_MODE.E_COLOR;
                    break;
                case DEBUG_MODE.WARNING:
                    heading = "📒 Warning:";
                    color = DEBUG_MODE.W_COLOR;
                    break;
                case DEBUG_MODE.NOTICE:
                    heading = "🗒️ Notice:";
                    color = DEBUG_MODE.N_COLOR;
                    break;

            }
            console.log(
                `%c${heading} %c${msg} 🏴‍☠️`,
                `
        color: ${color};
        font-family: sans-serif;
        font-size: .9rem;
        padding: .5rem;
    `, `color: inherit;
        font-family: sans-serif;
        font-size: .8rem;
        padding: .5rem;
        padding-left: 0;
    `);
        }
    });
}

export function debugMode(lvl = DEBUG_MODE.ERROR) {
    store(false).set(DEBUG_MODE.KEY, lvl)
}

export function store(volatile: boolean = true, id: string = "_") {

    function createStore() {
        if (volatile) {
            (window as any)[DEF_STORE_ID] = (window as any)[DEF_STORE_ID] || {};
            (window as any)[DEF_STORE_ID][id] = (window as any)[DEF_STORE_ID][id] || {};
        } else {
            localForage.config({
                name: `${DEF_STORE_ID}.${id}`,
                storeName: `${DEF_STORE_ID}.${id}`,
            } as any);
        }
    }

    function get(key: string) {
        createStore();

        if(volatile) {
            return new Promise((resolve) => {
                resolve((window as any)[DEF_STORE_ID][id][key]);
            });
        } else {
            return localForage.getItem(key);
        }
    }

    function set(key: string, value: any) {
        createStore();

        if(volatile) {
            return new Promise((resolve) => {
                (window as any)[DEF_STORE_ID][id][key] = value;
                resolve(value);
            }).catch((error) => {
                debug(error, DEBUG_MODE.ERROR);
            });
        } else {
            return localForage.setItem(key, value).catch((error: any) => {
                debug(error, DEBUG_MODE.ERROR);
            });
        }
    }

    function purge () {
        if(volatile) {
            delete (window as any)[DEF_STORE_ID];
        } else {
            localForage.clear().then(() => {
                debug("The store was cleared successfully", DEBUG_MODE.NOTICE);
            }).catch((error: any) => {
                debug(error, DEBUG_MODE.ERROR);
            });
        }
    }


    return {
        get,
        set,
        purge
    };

}

export function debounce(callback: any, timeout = 500) {
    let timer: any;
    //@ts-ignore
    let context: any = this;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback.apply(context, args);
        }, timeout);
    };
}


export function createLegendList(_chart: any, id: any) {
    const legendContainer = document.getElementById(id) as HTMLElement;
    let listContainer = legendContainer.querySelector('ul') as HTMLElement;

    if (!listContainer) {
        listContainer = document.createElement('ul');

        legendContainer.appendChild(listContainer);
    }

    return listContainer;
}

export function initDoughnutChart({ctx, reverse, type, labelText, data, backgroundColor} : {ctx: any; reverse: boolean; type: any; labelText: any; data: any; backgroundColor: any;}) {

    const chartWrapper = document.querySelector('.wrapper') as HTMLElement;

    if (reverse) {
        chartWrapper.classList.add('reverse')
    };

    new Chart(ctx, {
        type: type,
        data: {
            labels : labelText,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColor,
                }
            ],
        },
        options: {
            cutout: 140,
            responsive: true,
            maintainAspectRatio: true,
        },
    });
}


